import React from 'react'
import { FaMinus } from 'react-icons/fa';


function Tenth() {
  return (
    <section className='ten'>
        <div className="right">
            <h1>As Fast and Easy as Sending a Text</h1>
            <p>Send cash in just a few taps and watch it arrive instantly.</p>
            <span>
                <FaMinus/> 
                Get started with Chipper Cash
            </span>
        </div>

        <div className="left">

        </div>
        
    </section >
  )
}

export default Tenth